module.exports = __webpack_public_path__ + "static/img/cdb2.2a837d58.png";